import { LoaderSectionIDsEnum } from './../../../models/enums/General/LoaderSectionIDsEnum';
import { AuthService } from './../../../services/auth.service';
import { LoadingService } from './../../../services/loading.service';
import { Component, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { VehicleReservationSearchParm } from 'src/app/models/VehicleReservationSearchParm';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchService } from 'src/app/services/search.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-Main',
  templateUrl: './Main.component.html',
  styleUrls: ['./Main.component.css']
})
export class MainComponent implements OnInit,OnDestroy,AfterViewInit {

  searchModel: VehicleReservationSearchParm;
  componentType;
  customerID;

  subscriptions:Subscription[]=[];

  constructor(private authService:AuthService,private loadingService: LoadingService, private route: ActivatedRoute, private searchService: SearchService, private router: Router) { }
  ngAfterViewInit(): void {

  }

  ngOnInit() {

    this.componentType = 1;
    //const searchModelJson = this.route.snapshot.paramMap.get('search');

    this.subscriptions.push(this.authService.loggedInCustomer.subscribe(customer =>{

      this.subscriptions.push(this.searchService.searchModel.subscribe(res => {

        this.searchModel = res;
        this.searchModel.PageNumber=1;
        //IF response is null (refreshed the page or come directly to this path)
       /*  if (res == null) {
          //Chech if there is a cached searchModel
          let _chachedSearch = this.searchService.getCachedSearchModel();
          if (_chachedSearch != null) {
            this.searchService.updateSearchModel(_chachedSearch);
            this.searchModel = _chachedSearch;
          }
          else {
            //redirect to home page
            this.router.navigate(['/home']);
          }
        }
        else {
          this.searchModel = res;
        } */
        if(customer!=null){
          this.searchModel.CustomerID=customer.customerID;
        }

        if (this.searchModel.AgencyID != null) {



          this.loadingService.showViewLoader(LoaderSectionIDsEnum.MainComponentVehicleReservationSearchByAgency);
          this.searchService.VehicleReservationSearchByAgency(this.searchModel)
            .subscribe(res => {

              setTimeout(() => {
                this.loadingService.updateLoadingState(false);
              });


              this.searchService.updateVehicleReservationSearchAgency(res);
              this.loadingService.hideViewLoader(LoaderSectionIDsEnum.MainComponentVehicleReservationSearchByAgency);
            },err=>{
              this.loadingService.hideViewLoader(LoaderSectionIDsEnum.MainComponentVehicleReservationSearchByAgency);
            })


        }
        else {
          this.VehicleReservationSearch(this.searchModel);
        }



      }));


    }))

    //this.searchService.updateSearchModel(JSON.parse(searchModelJson));

  }
  VehicleReservationSearch(searchModel) {
    this.loadingService.showViewLoader(LoaderSectionIDsEnum.MainComponentVehicleReservationSearch);
    delete searchModel.AgencyID;
    delete searchModel.DropUpLocationAgencyId;
    //delete searchModel.ToAgencyID;

    this.subscriptions.push(this.searchService.VehicleReservationSearch(searchModel)
      .subscribe(res => {



        this.searchService.levelZeroTotalCount=res.totalCount;
        var branchList = this.searchService.vehicleReservationResultToBranch(res.lstVehicleReservationSearchResultModel);
        //Update the Branch Store by load the new branch list
        this.searchService.loadBranchList(branchList);
        setTimeout(() => {
          this.loadingService.updateLoadingState(false);
        });
        this.loadingService.hideViewLoader(LoaderSectionIDsEnum.MainComponentVehicleReservationSearch);
      }, err => {
        this.loadingService.updateLoadingState(false);
        this.loadingService.hideViewLoader(LoaderSectionIDsEnum.MainComponentVehicleReservationSearch);


      }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(item =>{
      item.unsubscribe();
    })
  }

}
